<template>
    <div ref="autocomplete" class="autocomplete" >
      <input
        type="text"
        @input="onChange"
        v-model="search"
        placeholder="start typing to search"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
      />
      <ul
        id="autocomplete-results"
        v-show="isOpen"
        class="autocomplete-results"
      >
        <li
          class="loading"
          v-if="isLoading"
        >
          Loading results...
        </li>
        <li
          v-else
          v-for="(result, i) in results"
          :key="i"
          @click="setResult(result)"
          class="autocomplete-result"
          :class="{ 'is-active': i === arrowCounter }"
        >
          {{ result.data }}
        </li>
      </ul>
    </div>
  </template>
  
<script setup>

    import { onMounted, ref, inject, watch, nextTick, onDeactivated } from 'vue'
    import RendiliCore from '@RendiliCore'
    
    const props = defineProps([ 'items', 'isAsync' ])
    const emit = defineEmits([ 'chosen', 'input' ])

    const isOpen = ref(false)
    const results = ref([])
    const search = ref('')
    const isLoading = ref(false)
    const arrowCounter = ref(-1)
    const autocomplete = ref(null)

    defineOptions({
        name: 'SearchAutocomplete'
    })

    onMounted(() => {
        document.addEventListener('click', handleClickOutside)
    })

    watch(() => props.items, async (newValue, oldValue) => {
        if(newValue !== oldValue){
            results.value = newValue;
        }
        isLoading.value = false;
        if(results.value.length)
          isOpen.value = true;
        else 
        isOpen.value = false;
    }, { immediate: true })

    onDeactivated(() => {
        document.removeEventListener('click', handleClickOutside)
    })


    function setResult(result) {
        search.value = result.data;
        isOpen.value = false;

        emit('chosen', result);
    }

    function filterResults() {
        return props.items
        results.value = props.items.filter((item) => {
            return item.data.toLowerCase().indexOf(search.value.toLowerCase()) > -1;
          });
          console.log(results)
    }
    
    function onChange() {
        if (props.isAsync) {
            isLoading.value = true;
            emit('input', search.value);
        } else {
            filterResults();
        }
    }
    
    function handleClickOutside(event) {
     if(autocomplete.value == null)
        return

      if (autocomplete.value.contains(event.target)) {
        isOpen.value = false;
        arrowCounter.value = -1;
      }
    }

    function onArrowDown() {
        if (arrowCounter.value < results.value.length) {
        arrowCounter.value = arrowCounter.value + 1;
        }
    }

    function onArrowUp() {
        if (arrowCounter.value > 0) {
        arrowCounter.value = arrowCounter.value - 1;
        }
    }

    function onEnter() {
        search.value = results.value[arrowCounter.value].data;
        isOpen.value = false;
        arrowCounter.value = -1;
    }

  </script>
  
  <style>
    .autocomplete {
      position: relative;
    }
  
    .autocomplete-results {
      padding: 0;
      margin: 0;
      border: 1px solid #eeeeee;
      height: 120px;
      overflow: auto;
    }
  
    .autocomplete-result {
      list-style: none;
      text-align: left;
      padding: 4px 2px;
      cursor: pointer;
    }
  
    .autocomplete-result.is-active,
    .autocomplete-result:hover {
      background-color: #dd8f55;
      color: white;
    }
  </style>